import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=ce86a376&scoped=true&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=ce86a376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce86a376",
  null
  
)

export default component.exports